/**
 * Retrieves all trigger items from the recipe.
 *
 * @return {Object[]} An array of trigger items.
 */
const getItemsTriggers = () => {
	return UncannyAutomator._recipe.triggers.items;
}

export default getItemsTriggers;
